import { PermissionInfo } from '@/types'
import { Column } from '@/components/Table'

export const permissionColumns: () => Column<
  PermissionInfo & { action?: unknown }
>[] = () => [
  {
    id: 'name',
    label: '权限',
    width: 200,
  },
  {
    id: 'scope',
    label: '类型',
    width: 200,
  },
  {
    id: 'description',
    label: '说明',
  },
]
